import React from 'react';
import { styled } from '@compiled/react';
import Icon from '@atlaskit/icon';
// eslint-disable-next-line jira/restricted/@atlassian+jira-common-styles
import { gridSize } from '@atlassian/jira-common-styles/src';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages';

const AddFeatureFlagGlyph = () => (
	<svg
		width={gridSize * 3}
		height={gridSize * 3}
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M17 2C17.5523 2 18 2.44772 18 3V5H20C20.5523 5 21 5.44772 21 6C21 6.55228 20.5523 7 20 7H18V9C18 9.55228 17.5523 10 17 10C16.4477 10 16 9.55228 16 9V7H14C13.4477 7 13 6.55228 13 6C13 5.44772 13.4477 5 14 5H16V3C16 2.44772 16.4477 2 17 2ZM12.2444 4.49608C12.3613 4.52442 12.477 4.55249 12.5917 4.57991C12.2263 4.9423 12 5.44472 12 6C12 6.17625 12.0228 6.34718 12.0656 6.50999C11.966 6.48607 11.867 6.46205 11.7688 6.43821L11.768 6.43801L11.7623 6.43662L11.7623 6.43662C10.3856 6.10219 9.16838 5.80649 8 6.14801V10.852C8.36666 10.7863 8.7385 10.7539 9.111 10.755C10.205 10.755 11.259 11.011 12.24 11.25C13.621 11.585 14.84 11.88 16.008 11.539V10.737C16.3004 10.9044 16.639 11 17 11C17.3676 11 17.712 10.9008 18.008 10.7278V12.221C18.0081 12.4088 17.9554 12.5927 17.8558 12.7519C17.7562 12.9111 17.6139 13.039 17.445 13.121C16.6509 13.5034 15.7793 13.6974 14.898 13.688C13.8103 13.688 12.7622 13.434 11.785 13.1971L11.785 13.1971L11.768 13.193C10.389 12.858 9.17 12.562 8 12.903V18.681C8 19.218 7.55 19.658 7 19.658C6.45 19.658 6 19.218 6 18.681V12.235V5.46601C6 5.27855 6.05268 5.09486 6.15205 4.93591C6.25143 4.77695 6.39348 4.64912 6.562 4.56701C8.553 3.60001 10.511 4.07501 12.24 4.49501L12.2444 4.49608Z"
			fill="currentcolor"
		/>
	</svg>
);

export const AddFeatureFlagIcon = () => {
	const { formatMessage } = useIntl();

	return (
		<IconWrapper>
			<Icon
				testId="software-releases-version-detail-issue-list.ui.issues.issue-card.feature-flags.add-feature-flag.icon.icon"
				glyph={AddFeatureFlagGlyph}
				size="medium"
				label={formatMessage(messages.addFeatureFlagIconLabel)}
			/>
		</IconWrapper>
	);
};

// eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const IconWrapper = styled.div({
	display: 'flex',
	alignItems: 'center',
});
